import { connect } from 'react-redux'
import LanguageCurrencyModal from '../components/LanguageCurrencyModal'
import UserAccountRedux from '../redux/UserAccountRedux'
import DisplayRedux from '../redux/DisplayRedux'

const mapStateToProps = ({ userAccount , display} ) => ({
    countries: userAccount.countries,
    currency: userAccount.currency,
    billingCountry: userAccount.billingCountry,
    campaignCurrency: display.campaignCurrency,
    campaignInvoiceIssuingCountry: display.campaignInvoiceIssuingCountry,
    campaignBillingCountry: display.campaignBillingCountry,
    location: userAccount.location,
    user: userAccount.user,
    editCampaignActive: display.editCampaignActive,
    currentCampaign: display.currentCampaign,
    dsp: display.dsp,
    programmatic: display.programmatic,
    isSuperUser: userAccount.isSuperUser,
    conversionRates: display.conversionRates,
    amountBudget: display.amountBudget,
})

const mapStateToDispatch = (dispatch) => ({
    getCountries: () => dispatch(UserAccountRedux.getCountriesRequest()),
    setBilling: (currency, country, codeCountry)=> dispatch(UserAccountRedux.setBilling(currency, country, codeCountry)),
    setCampaignBillingInfo: (currency, billingCountry, invoiceIssuingCountry)=> dispatch(DisplayRedux.setCampaignBillingInfo(currency, billingCountry, invoiceIssuingCountry)),
    getlocation: () => dispatch(UserAccountRedux.getLocationRequest()),
    getConversionRates: () => dispatch(DisplayRedux.getConversionRatesRequest()),
    setBudget: (amountBudget) => dispatch(DisplayRedux.setBudget(amountBudget)),
    convertAndSetBudget: (selectedCurrency) => dispatch(DisplayRedux.convertAndSetBudget(selectedCurrency)),
})

export default connect(mapStateToProps, mapStateToDispatch)(LanguageCurrencyModal)